export default (params) => ({
  trigger: {
    name: 'add_to_cart_page.select_product_title',
    params: params,
  },
  config: {
    schema: {
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      method: {
        enum: [
          'image',
          'title',
          'link',
        ],
      },
      item_id: {
        type: 'integer',
      },
      sub_feature: {
        enum: [
          'employee_atc_page',
          'customer_atc_page',
          'top_of_page',
          'business_atc_page',
        ],
      },
    },
    event: {
      name: 'select_item',
    },
  },
});
